export default __webpack_public_path__ + "static/media/teacher.f766d64e.webp";